import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { LayoutDashboard, Users, ClipboardCheck, CreditCard, LogOut, Landmark } from 'lucide-react';
import { BrandLogo } from '../BrandLogo';

const NAV = [
  { to: '/admin/dashboard', label: 'Overview', icon: LayoutDashboard },
  { to: '/admin/drivers', label: 'Drivers', icon: ClipboardCheck },
  { to: '/admin/bookings', label: 'Bookings', icon: Users },
  { to: '/admin/transactions', label: 'Transactions', icon: CreditCard },
  { to: '/admin/payouts', label: 'Payouts', icon: Landmark },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-muted flex">
      {/* Sidebar */}
      <aside className="w-64 bg-primary-dark text-background flex flex-col">
        <div className="px-6 py-6 border-b border-white/10 flex items-center gap-3">
          <div className="rounded-lg bg-white px-2 py-1.5">
            <BrandLogo variant="compact" className="h-6 w-auto" />
          </div>
          <p className="text-xs text-background/60">Admin console</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? 'bg-accent text-primary-dark font-semibold'
                    : 'text-background/60 hover:bg-white/10 hover:text-background'
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/10">
          <Button
            variant="ghost"
            className="w-full justify-start text-background/60 hover:text-background hover:bg-white/10"
            onClick={handleLogout}
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto px-6 py-8">{children}</div>
      </main>
    </div>
  );
}
